<template>
  <div id="jac-region-create" class="create-container">
    <v-card class="custom-card">
      <div class="custom-app-bar px-6 py-4">
        <v-row
          align="center"
          justify="space-between"
          class="ma-0 header-content"
        >
          <div class="d-flex flex-column">
            <h6 class="subtitle-text text-uppercase mb-1">Create New Region</h6>
            <h2 class="title-text text-h5 font-weight-bold mb-0">
              JAC Regional Create
            </h2>
          </div>
          <v-btn @click="closePrompt" class="btn-close-icon" elevation="2" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </div>
      <v-container class="px-6 py-6" style="overflow: hidden">
        <v-card-text class="pt-2">
          <div class="d-flex justify-content-center mb-4" v-if="LoadingFlag">
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
              style="color: #3a67b1"
            ></b-spinner>
          </div>
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="submitForm"
          >
            <v-container class="pa-0">
              <v-row wrap class="mb-2">
                <v-col cols="12" md="12" class="pb-0">
                  <p class="required-notice">
                    <span class="required-asterisk">*</span> indicates required
                    field
                  </p>
                </v-col>
              </v-row>

              <div class="form-wrapper mb-6">
                <v-row wrap>
                  <v-col cols="12" sm="6" lg="3" md="3" class="py-2">
                    <label class="form-label">
                      <span class="required-asterisk">*</span> Zone
                    </label>
                    <v-autocomplete
                      :reduce="(option) => option.value"
                      :loading="ZoneCodeOptionsLoading"
                      :items="ZoneCodeOptions"
                      :rules="ZoneCodeRules"
                      v-model="ZoneCode"
                      dense
                      clearable
                      required
                      outlined
                      hide-details="auto"
                      background-color="#FFFFFF"
                      color="#3A67B1"
                      class="custom-input"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" sm="6" lg="3" md="3" class="py-2">
                    <label class="form-label">
                      <span class="required-asterisk">*</span> Region Name
                    </label>
                    <v-text-field
                      v-model="RegionName"
                      :rules="RegionNameRules"
                      placeholder="Enter Region Name"
                      required
                      outlined
                      dense
                      hide-details="auto"
                      background-color="#FFFFFF"
                      color="#3A67B1"
                      class="custom-input"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" lg="3" md="3" class="py-2">
                    <label class="form-label">
                      <span class="required-asterisk">*</span> Region Display
                      Text
                    </label>
                    <v-text-field
                      v-model="RegionDisplayText"
                      :rules="RegionDisplayTextRules"
                      placeholder="Enter Display Text"
                      required
                      outlined
                      dense
                      hide-details="auto"
                      background-color="#FFFFFF"
                      color="#3A67B1"
                      class="custom-input"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" lg="3" md="3" class="py-2">
                    <label class="form-label">Active Status</label>
                    <v-switch
                      v-model="ActiveStatus"
                      :label="`${ActiveStatus ? 'Active' : 'Inactive'}`"
                      color="#56BDA3"
                      inset
                      :true-value="1"
                      :false-value="0"
                      hide-details
                      class="custom-switch mt-1"
                    ></v-switch>
                  </v-col>
                </v-row>
              </div>

              <v-divider class="my-6 custom-divider"></v-divider>

              <v-row wrap>
                <v-col
                  align="center"
                  cols="12"
                  md="12"
                  class="d-flex justify-center gap-4 mt-2"
                >
                  <v-btn
                    @click="closePrompt"
                    class="btn-close px-10 py-5"
                    elevation="0"
                    outlined
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="submitForm"
                    :loading="SubmitFlag"
                    class="btn-submit px-10 py-5"
                    elevation="0"
                  >
                    <v-icon left size="20">mdi-plus</v-icon> Create Region
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      RegionName: "",
      RegionNameRules: [(v) => !!v || "Region Name is required"],

      RegionDisplayText: "",
      RegionDisplayTextRules: [(v) => !!v || "Region Display Text is required"],

      ActiveStatus: 0,
    };
  },
  watch: {
    ZoneCodeOptions: function () {
      this.ZoneCodeOptionsLoading = false;
    },
  },
  mounted() {
    this.getZoneCodeOptions();
  },
  methods: {
    closePrompt() {
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    getZoneCodeOptions() {
      this.ZoneCodeOptionsLoading = true;
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/zone/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    submitForm() {
      var validate1 = this.$refs.form1.validate();
      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jac-region/store";
        var upload = {
          UserInterface: 1,
          Zone: this.ZoneCode,
          RegionName: this.RegionName,
          RegionDisplayText: this.RegionDisplayText,
          ActiveStatus: this.ActiveStatus,
        };

        const thisIns = this;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            thisIns.SubmitFlag = false;

            var output = response.data.output;
            var flag = response.data.flag;

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.SubmitFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
  },
};
</script>

<style scoped>
.create-container {
  font-family: "Inter", "Roboto", sans-serif;
}

.custom-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 10px 30px -5px rgba(10, 15, 41, 0.08),
    0 4px 6px -2px rgba(10, 15, 41, 0.04) !important;
  background-color: #ffffff !important;
  border: 1px solid rgba(65, 64, 66, 0.05);
}

.custom-app-bar {
  background: linear-gradient(135deg, #3a67b1 0%, #2c508a 100%) !important;
  position: relative;
  overflow: hidden;
  border-bottom: none !important;
}
.custom-app-bar::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(
      circle at 15% 50%,
      rgba(255, 255, 255, 0.06) 0%,
      rgba(255, 255, 255, 0.06) 120px,
      transparent 120px
    ),
    radial-gradient(
      circle at 85% 30%,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0.04) 180px,
      transparent 180px
    ),
    radial-gradient(
      circle at 50% 120%,
      rgba(255, 255, 255, 0.03) 0%,
      rgba(255, 255, 255, 0.03) 250px,
      transparent 250px
    );
  pointer-events: none;
}
.header-content {
  position: relative;
  z-index: 1;
}

.title-text {
  color: #ffffff !important;
  letter-spacing: 0.5px;
}

.subtitle-text {
  color: #edbe38 !important;
  letter-spacing: 1.5px;
  font-weight: 700;
  font-size: 0.75rem;
}

.btn-close-icon {
  background-color: rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  transition: all 0.3s ease;
}
.btn-close-icon:hover {
  background-color: rgba(255, 255, 255, 0.25) !important;
  transform: rotate(90deg);
}

.required-notice {
  font-size: 0.85rem;
  color: #414042;
  font-weight: 500;
  margin-bottom: 0;
}

.required-asterisk {
  color: #edbe38;
  font-weight: bold;
  font-size: 1rem;
}

.form-wrapper {
  background-color: #ffffff;
  border: 1px solid rgba(65, 64, 66, 0.08);
  box-shadow: 0 2px 12px rgba(10, 15, 41, 0.03);
  border-radius: 12px;
  padding: 24px 24px;
}

.form-label {
  color: #414042;
  font-weight: 600;
  margin-bottom: 6px;
  display: block;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.custom-input.v-text-field--outlined ::v-deep fieldset {
  border-color: rgba(65, 64, 66, 0.15) !important;
  transition: all 0.2s ease;
}
.custom-input.v-text-field--outlined:hover ::v-deep fieldset {
  border-color: rgba(65, 64, 66, 0.3) !important;
}
.custom-input.v-text-field--outlined.v-input--is-focused ::v-deep fieldset {
  border-color: #3a67b1 !important;
  border-width: 2px !important;
}
.custom-input.v-text-field--outlined.v-input--is-focused
  ::v-deep
  .v-input__slot {
  box-shadow: 0 0 0 4px rgba(58, 103, 177, 0.15) !important;
}
.custom-input ::v-deep .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 8px !important;
  min-height: 44px !important;
  box-shadow: inset 0 1px 2px rgba(10, 15, 41, 0.02) !important;
}
.custom-input ::v-deep input,
.custom-input ::v-deep .v-select__selection {
  color: #0a0f29 !important;
  font-weight: 500;
  font-size: 0.95rem;
}

.custom-switch ::v-deep .v-label {
  font-weight: 600;
  color: #0a0f29;
}

.custom-divider {
  border-color: rgba(65, 64, 66, 0.08) !important;
}

.btn-submit {
  background-color: #3a67b1 !important; /* NAVY */
  color: #ffffff !important;
  border-radius: 8px;
  text-transform: none !important;
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(58, 103, 177, 0.2) !important;
}

.btn-submit:hover {
  background-color: #2c508a !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(58, 103, 177, 0.25) !important;
}

.btn-close {
  background-color: #ffffff !important;
  color: #e53935 !important; /* Premium Red */
  border: 1px solid rgba(229, 57, 53, 0.3) !important;
  border-radius: 8px;
  text-transform: none !important;
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.btn-close:hover {
  background-color: #e53935 !important;
  color: #ffffff !important;
  box-shadow: 0 4px 8px rgba(229, 57, 53, 0.2) !important;
  border-color: #e53935 !important;
  transform: translateY(-1px);
}

.gap-4 {
  gap: 16px;
}
</style>
